import { gate } from 'hub-http/gates';
import { useGetIsUngated } from '../../../v2/hooks/useGetIsUngated';
import useSourceId from '../../../v2/hooks/useSourceId';
import { SmartPropertyCitationPopover } from 'smart-property-lib';
import { useState, useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { parsePropertySourceIdSmartPropertyResultId } from 'customer-data-objects/property/PropertySourceIdentifier';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';

/**
 * This JSX is a hook instead of a component because we need to check conditionally whether the rendered result is truthy/falsy,
 * in order to be able to not pass content to FormControl's hoverContent prop.
 *
 * Were this a component, its 'value' would always be truthy and we would wind up passing empty, but present, hover content.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useGetSourceCitationHoverContent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const getIsUngated = useGetIsUngated();
  const hasSmartPropertyCitationsGate = getIsUngated(gate('CRM:Properties:SmartPropertyCitations'));
  const {
    data: sourceId
  } = useSourceId({
    skip: !hasSmartPropertyCitationsGate
  });
  const parsedSmartPropertySourceId = parsePropertySourceIdSmartPropertyResultId(sourceId);
  return useMemo(() => {
    const handleOpenChange = event => {
      setIsOpen(event.target.value);
    };
    const handleClick = () => {
      setIsOpen(prev => !prev);
    };
    if (!hasSmartPropertyCitationsGate || !parsedSmartPropertySourceId) {
      return null;
    }
    return /*#__PURE__*/_jsx(SmartPropertyCitationPopover, {
      smartPropertyResultId: parsedSmartPropertySourceId,
      onOpenChange: handleOpenChange,
      open: isOpen,
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        size: "xs",
        onClick: handleClick,
        children: /*#__PURE__*/_jsxs(Flex, {
          gap: "50",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(BreezeSingleStarIcon, {
            color: "fill-accent-magenta-default"
          }), /*#__PURE__*/_jsx(Text, {
            color: "fill-accent-magenta-default",
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataProperties.formControl.AI"
            })
          })]
        })
      })
    });
  }, [hasSmartPropertyCitationsGate, parsedSmartPropertySourceId, isOpen]);
};